import { Flex } from "@aircall/tractor";
import styled, { getColor } from "@xstyled/styled-components";

export const StyledFlex = styled(Flex)`
  padding: m;
  border-radius: 8px;
  border: 1px solid ${getColor("surface-interactive-neutral")};
`;
